// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios';
import mavonEditor from 'mavon-editor'
import '@/style/common.css'
import 'mavon-editor/dist/css/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
import store from './store'//引入store
import VCharts from 'v-charts'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(mavonEditor)
Vue.use(VCharts)
Vue.use(animated)//使用animate动画
//把axios 挂载到vue的原型
Vue.prototype.$axios = axios;
// Vue.prototype.$axios = axios.create({
//   baseURL: 'https://admin.congraedu.cn'
//   // baseURL: 'http://172.168.1.60:7001'
// })
axios.interceptors.request.use(
  config => {
    
    let token = localStorage.getItem('token');
    // console.log(token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  },
)

router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
		return next()
	}
  if (!localStorage.getItem('token')) {
		return next('/login')
	} else {
		next()
	}
	// ...
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js